export const TRANSLATIONS_EN = () => {
  return {
    deliver: 'Deliver',
    myOrders: 'My Orders',
    update: 'Update',
    required: 'Required',
    products: 'Products',
    unitsAvailable: 'Units Available',
    buy: 'Buy',
    sell: 'Sell',
    sellTo: 'Sell To',
    no: 'No',
    notFound: 'Found',
    withThisMobileNumber: 'With This Mobile Number No',
    foundWithMobile: 'found with this mobile number',
    notFoundWithMobile: 'Not found with mobile number',
    addNew: 'Add New',
    addNewRetailer: 'Add New Retailer',
    retailer: 'Retailer',
    addNewMason: 'Add New Shilpkar',
    addNewProject: 'Add New Project',
    upload: 'Upload',
    photo: 'Photo',
    idProof: 'Id Proof',
    registerSell: 'Register & Sell',
    registeremployee: 'Register',
    address: 'Address',
    somethingWentWrong: 'Something went wrong',
    submit: 'Submit',
    quantity: 'Quantity',
    brand: 'Brand',
    buyer: 'Buyer',
    number: 'Number',
    company: 'Firm',
    companies: 'Companies',
    available: 'Available',
    otpSent: 'OTP Sent',
    pincode: 'Pincode',
    next: 'Next',
    prev: 'Prev',
    somewrong: 'Something went wrong',
    noCompanySelected: 'No Firm Selected',
    noProductSelected: 'No Product Selected',
    noIdProof: 'No ID proof Photo provided',
    noPhotoError: 'No Photo provided',
    maxQuantityExceed: 'Max Quantity Exceeded',
    passwordNotMatch: 'Password do not match',
    acceptTerms: 'Please accept terms and conditions',
    noInvoiceFileFound: 'No Invoice File Found',
    retailerChoosenMultiple: 'Single retailer choosen multiple time',
    success: 'Success',
    sellInvoiceDone: 'Sell Invoice Created Successfully',
    annualSales: 'Annual Sales',
    monthlySales: 'This Months Sales',
    otp: 'OTP',
    otpRequired: 'OTP Required',
    sendToRetailer: 'Send To Retailer',
    termsAndConditionsApplied: 'T&C',
    gift: 'Rewards',
    sellInvoices: 'Sell Invoices',
    humbeeBenefits: 'HUMBEE Benefits',
    enterLanguage: 'Enter Language',
    enterDisease: 'Enter Disease',
    name: 'Name',
    firmEmail: 'Firm Email',
    date: 'Date',
    total: 'Total',
    baseproduct: 'Base Product',
    todayprice: "Today's Price",
    profiler: {
      addPersonalPanNo: 'Add Personal Pan No.',
      profiler: 'Profiler',
      businessProfiler: 'Business Profiler',
      personalProfiler: 'Know You Better',
      firmName: 'Firm Name',
      firmType: 'Firm Type',
      propertiorName: 'Propertior/Partner/Director Name',
      cementVolume: 'Cement Volume',
      otherAncillary: 'Other Business',
      qualification: 'Qualification',
      enterQualification: 'Enter Qualification',
      prefferedLanguage: 'Favourite language',
      marriageAnniversary: 'Marriage Anniversary',
      doYouHaveAnyHealthConsern: 'Do You Have Any Health Conditions',
      facebookId: 'Facebook ID',
      whatsappNo: 'Whatsapp No',
      dateOfBirth: 'Date Of Birth',
      food: 'Love to Eat',
      drinks: 'I Love Drinks',
      postRetirement: 'Post Retirement',
      presentlyParticipating: 'Prensently Participating',
      familyDetails: 'Family Details',
      destinationsVisited: 'Destinations Visited/Want To Visit',
      doYouSeeYourNextGenerationParticipatingInYourBusiness:
        'Do You See Your Next Generation Participating in Your Business?',
      timeFromApprox: 'Time From Approx',
      yourManagerName: 'Your Manager Name',
      gender: 'Gender',
      phoneNo: 'Phone Number',
      noOfShilpkar: 'No. of Shilpkar',
      noOfRetailer: 'No. of Retailer',
      yearlyTurnOver: 'Yearly Turn Over',
      managerDetails: 'Manager Details',
      maritialStatus: 'Married',
    },
    gifts: {
      rewards: 'Rewards',
      type: 'Type',
      rewardsDeatils: 'Lucky Draw',
      beneficiarysName: 'Beneficiary name',
      productName: 'Product',
      status: 'Status',
      updateStatus: 'Update Status',
      redeemAndUpdateStatus: 'Redeem And Update Status',
      pleaseUploadImagesOfGift: 'Please upload images of Gift',
      myRetailersGiftTransactions: 'My Retailers Gift Transactions',
      retailerName: 'Retailer Name',
      masonName: 'Shilpkar Name',
      giftName: 'Gift Name',
    },
    login: {
      userDoesntExists: "User Doesn't Exists",
      doYouWantToRegisterNow: 'Do You Want To Register Now?',
      welcome: 'Welcome',
      username: 'Mobile',
      searchMobile: 'Search Mobile',
      password: 'Password',
      usernamePlaceholder: 'Mobile Number',
      usernamePlaceholderNew: 'New Mobile Number',
      signIn: 'SIGN IN',
      forgotPassword: 'Forgot Password',
      noAccount: "Don't have an account?",
      newUserRegisterNow: 'NEW USER REGISTER NOW',
      noUsername: 'Please input your mobile!',
      noPassword: 'Please input your password!',
      recovery: 'Recover',
      loginUsing: 'Login Using',
      resendAfter: 'Resend After',
    },
    benefits: {
      Aggregation: 'सम्पूर्ण क्वांटिटी के आधार पर लाभ',
      LifeInsurance: 'जीवन बीमा',
      MedicalInsurance: 'स्वास्थ्य बीमा',
      GoldenAgePlan: 'गोल्डन एज प्लान',
      Tours: 'आकर्षक वार्षिक टूर',
    },
    register: {
      newUser: 'New User',
      registerHere: 'Register Here',
      email: 'Email',
      emailPlaceholder: 'Enter your registered email',
      mobileNo: 'Mobile No',
      createPassword: 'Create Password',
      confirmPassword: 'Confirm Password',
      passwordAgain: 'Type password again',
      mobilePlease: 'Mobile No. please',
      signUp: 'SIGN UP',
      alreadyHaveAccount: 'Already have an account!',
      signIn: 'Sign in',
      noMobileNo: 'Please input your mobile no!',
      noEmail: 'Please input your email!',
      noPassword: 'Please input your password!',
      noConfirmPassword: 'Please input your confirm password!',
      passwordLengthError: 'Password length should be at least 8.',
    },
    benefitscertificates: {
      certificates: 'Insurance Certificates',
      certificate: 'Certificate Type',
      certificateName: 'Certificate Name',
      certificateDownload: 'Action',
      downloadcrtificate: 'Download Certificate',
    },
    verify: {
      otp: 'OTP',
      sent: 'Sent',
      send: 'Send',
      title: 'Verify with OTP',
      otpOn: 'We have send an OTP on',
      registeredEmail: 'and your registered email address',
      codeNotReceived: "I didn't receive a code.",
      resend: 'Resend',
      itOr: 'It or',
      details: 'Details',
      changeRegistrationDetails: 'Change Registration Details',
      verify: 'Verify',
      resetPassword: 'Reset Password',
      oneTimePassword: 'One Time Password',
      otpForOldNumber: 'OTP for Old Phone Number',
      otpForNewNumber: 'OTP for New Phone Number',
    },
    onboarding: {
      editingShilpkar: 'Editing Shilpkar',
      warning: 'Warning',
      benefitsNotAvailableInYourAreaButStillYouCanContinue:
        'Benefits Not Available In Your Area But Still You Can Continue',
      wrongGstNumber: 'Wrong Gst Number',
      nowUAre: 'Now you are',
      onboarding: 'Onboarding',
      firstName: 'First Name',
      noName: 'Please input your first name',
      lastName: 'Last Name',
      noLastName: 'Please input your last name',
      companyName: 'Firm Name',
      firmName: 'Firm Name',
      yourCompanyName: 'Your Firm Name',
      noCompanyName: 'Please input your Firm name',
      registeredAs: 'Registered As',
      noRegisteredAs: 'Please select how you are registered as',
      distibutor: 'Distributor',
      gstNo: 'GST No.',
      noGstNo: 'Please input your GST No.',
      pleaseGstDetails: 'Please give gst details',
      panNo: 'PAN No.',
      noPanNo: 'Please input your PAN No.',
      pleasePanDetails: 'Please give pan details',
      companyPhoneNo: 'Firm Phone No.',
      noCompanyPhoneNo: 'Please input your Firm phone no.',
      companySupportNumber: 'Firm Support Number',
      companyAddress: 'Shop Address',
      state: 'State',
      city: 'District',
      district: 'District',
      streetAddress1: 'Street Address Line-1',
      streetAddress2: 'Street Address Line-2',
      postalCode: 'Postal Code',
      verify: 'Verify',
      terms: 'I have read and accepted the terms and conditions',
      accept: 'I have read and accepted the',
      acceptRetailer: 'Retailer have read and accepted the',
      conditions: 'Terms and Conditions',
      uploadPhoto: 'Upload Photo',
      uploadId: 'Upload Id',
      dealingWithCementCompanies: 'Dealing with Cement Companies',
      pleaseSelectRegisteredCementCompanies:
        'Please Select Registered Cement Companies',
      retailerFirmName: 'Retailer Firm Name',
      "Mason's": "Shilpkar's",
      "Retailer's": "Retailer's",
      "Project's": "Project's",
      otpSentToRetailer: 'OTP Sent To Retailer',
      retailerSell: 'Click on exiting Retailer for Sell to Retailer',
      masonSell: 'Click on exiting Shilpkar for Sell to Shilpkar',
      projectSell: 'Click on exiting Project for Sell to Project',
      associateSell: 'Click on exiting Associate for Sell to Associate',
    },
    distributor: {
      distributor: 'Distributor',
      project: 'Project',
      associate: 'Associate',
      hello: 'Hello',
      sellTo: 'Sell to',
      mason: 'Shilpkar',
      retailer: 'Retailer',
      dealer_reatiler: 'Dealer + retailer',
      myInventory: 'My Inventory',
      add: 'Add',
      viewAllInventory: 'View All Inventory',
      home: 'Home',
      stock: 'Stock',
      invoices: 'Invoices',
      settings: 'Settings',
      orders: 'Orders',
      masonOnboaded: 'Mason Onboarded',
    },
    addInvoice: {
      quantityType: 'Quantity Type',
      noQuantityTypeChoosen: 'No Quantity Type Choosen',
      youCanAddCompanyInProfileCompanyDealership:
        'You can add company in profile company dealership',
      addInvoice: 'Add Invoice',
      productAdded: 'Product Added',
      productsAdded: 'Products Added',
      companyName: 'Firm Name',
      quantity: 'Quantity',
      priceInInr: 'Unit Price (INR)',
      addItem: 'Add Item',
      editItem: 'Edit Item',
      itemsAdded: 'Items Added',
      continue: 'Continue',
      searchProduct: 'Search Product',
      searchCompany: 'Search Firm',
      details: 'Invoice Details',
      number: 'Invoice Number',
      num: 'Invoice No.',
      date: 'Invoice Date',
      sellingdate: 'Selling date',
      uploadFile: 'Upload File',
      totalAmount: 'Total Amount',
      invoices: 'Invoices',
      verified: 'Verified',
      pending: 'Pending',
      rejected: 'Rejected',
      noProductsWereAdded: 'No products were added',
      pleaseAddAtLeastOneProduct: 'Please add at least one product',
      invoiceCreatedSuccessfully: 'Invoice Created Successfully',
      success: 'Success',
      error: 'Error',
      productNotSelected: 'Product not selected',
      pleaseSelectAProduct: 'Please select a product',
      alreadyAdded: 'Already added',
      productAlreadyAdded: 'Product already added.',
      productRequired: 'Product Required',
      pleaseAddProducts: 'Please add products',
      noFilesSelected: 'No files are selected',
      invoiceDetails: 'Invoice Details',
      invoiceNumber: 'Invoice Number',
      invoiceDate: 'Invoice Date',
      invoice: 'Invoice',
      purchaseInvoice: 'Purchase Invoice',
      download: 'Download',
      files: 'Files',
      metricTonsAvailable: 'Metric-tons available',
      invoiceId: 'Invoice Id',
      priceIn: 'Price (INR WITH GST)',
      pleaseEnterInvoiceNumber: 'Please Enter Invoice number',
      pleaseUploadAnInvoiceFile: 'Please Upload Invoice File',
      invoiceVerify:
        'I verify that this bill detail is true and correct and I am marking it here for credit for the first time.',
      pleaseConfirmInvoiceDetailsByClickingCheckbox:
        'Please Confirm Invoice Details By Clicking Checkbox',
      edit: {
        edit: 'Edit Invoice',
        details: 'Edit Invoice Details',
      },
    },
    profile: {
      myProfile: 'My Profile',
      changeCredentials: 'Change Credentials',
      changePasswordUsingPhoneNumber: 'Change Password using phone number',
      changePassword: 'Change Password',
      supportfeedback: 'Support & Feedback',
      uploadFiles: 'Upload Files',
      idProofType: 'Id Proof Type',
      uploadIdProof: 'Upload Id Proof',
      uploadPhoto: 'Upload Photo',
      settings: 'Settings',
      logout: 'Logout',
      companyDetails: 'Firm Details',
      dealershipCompanies: 'Dealership companies',
      dealerPlaceHolder: 'Please select the dealership companies',
      addCompany: 'Add Firm',
      addEmployee: 'Add your employee/ partner',
      employee: 'Employee',
      editProfile: 'Edit Profile',
      changeLanguage: 'Choose Language',
      aadharCard: 'AADHAR CARD',
      aadhaarNo: 'Aadhaar No',
      panCard: 'PAN CARD',
      gstin: 'GSTIN',
      faq: 'FAQ',
      contactUs: 'Contact Us',
      deleteAccount: 'Delete Account',
      changePhoneNumber: 'Change Phone Number',
    },
    addProduct: {
      pleaseenterquantity: 'Please Enter Quantity ',
      pleaseselectproduct: 'Please Select Product',
      pleaseselectretailer: 'Please Select Retailer',
      searchproduct: 'Search Product',
      atprice: 'at price ',
      quantity: 'Quantity',
      addretailer: 'Add Retailer ',
      retailer: 'Retailer',
      additem: 'Add item ',
      delivertoself: 'Deliver To Self ',
      itemadded: 'Item Added ',
      itemsadded: 'Items Added ',
      continue: 'Continue',
      wasaddedwithquantity: ' was added with quantity ',
      additemtocontinue: 'Add Item To Continue',
      pleaseAddProductInInventoryToSell:
        'Please Add Product In Inventory To Sell',
    },
    checkout: {
      productsadded: 'Products Added ',
      viewallorders: 'View All Orders ',
      totalvalue: 'Total Value ',
      ordernow: 'Order now ',
      retailerformcannotbeempty: 'Retailer Form cannot be empty ',
      quantitycannotbelessthanretailersquantity:
        'Quantity Cannot be less than retailers Quantity ',
      atprice: 'At Price ',
      delivertoself: 'Deliver To self ',
      addretailer: 'Add Retailer ',
      retailer: 'Retailer',
      quantity: 'Quantity',
      update: 'Update',
      retrypayment: 'Retry Payment ',
      yourorderwasplaced: 'Your Order Was Placed',
      successfully: 'Successfully',
      ordernumber: 'Order Number',
      orderPayment: 'Order Payment',
    },
    orderDetails: {
      invoiceuploadedsuccessfully: 'Invoice uploaded successfully',
      retailer: 'Retailer',
      quantity: 'Quantity',
      address: 'Address',
      product: 'Product',
      price: 'Price',
      orderdetails: 'Order Details ',
      pleaseenterinvoicenumber: 'Please Enter Invoice Number ',
      adddeliveryinfo: 'Add delivery Info ',
      uploadorderinvoice: 'Upload Order Invoice ',
      submit: 'Submit',
      retailername: 'Retailer Name',
      invoicenumber: 'Invoice Number',
      status: 'Status',
      orderdeliverycompleted: 'Order Delivery Completed',
    },
    order: {
      doyouwanttochangecompany: 'Do You Want To Change Firm?',
      changingthecompanywillcleartheitemsaddedtothecart:
        'Changing the Firm will clear the items Added to the cart',
      ordernow: 'Order Now ',
      continue: 'Continue',
    },
    viewOrder: {
      orderid: 'Order Id ',
      retrypaymentforthisorder: 'Retry Payment For This Order ',
      yes: 'Yes',
      no: 'No',
      ordernow: 'Order Now',
      myorders: 'My Order Bookings',
      placeOrder: 'Place Order',
      xfactoryPrice: 'X Factory Price',
      loadingCharges: 'Loading Charges',
      addToCart: 'Add To Cart',
    },
    orderStatus: {
      INITIATED: 'INITIATED',
      PAYMENTCOMPLETED: 'PAYMENT COMPLETED',
      PAYMENTFAILED: 'PAYMENT FAILED',
      DELIVERED: 'DELIVERED',
      FAILED: 'FAILED',
      SUCCESS: 'SUCCESS',
      PENDING: 'PENDING',
      DISPATCHED: 'DISPATCHED',
      PAYMENTSENDTOSELLER: 'PAYMENT SEND TO SELLER',
      PARTIALPAYMENTDONE: 'PARTIAL PAYMENT DONE',
      PARTIALLYDELIVERED: 'PARTIALLY DELIVERED',
    },
    userType: {
      MASON: 'SHILPKAR',
      DISTRIBUTOR: 'DISTRIBUTOR',
      DEALER_RETAILER: 'DEALER + RETAILER',
      RETAILER: 'RETAILER',
      CEMENT_COMPANY: 'CEMENT_COMPANY',
      HUMBEE_SUPPORT: 'HUMBEE_SUPPORT',
      PROJECT: 'PROJECT',
      ASSOCIATE: 'ASSOCIATE',

      BARBENDER: 'SHILPKAR / BAR BENDER',
      ENGINEER: 'ENGINEER',
      BAR_BENDER: 'CONTACTOR',
      ARCHITECH: 'ARCHITECH',
      PAINTER: 'PAINTER',
      FABRICATOR: 'FABRICATOR',
    },
    inventory: {
      brand: 'Brand',
    },
    sellToBuyer: {
      sell: 'Sell',
      sellItem: 'Sell Item',
      sellToMason: 'Sell to Shilpkar',
      sellToProject: 'Sell to Project',
      sellToAssociate: 'Sell to Associate',
      sellToRetailer: 'Sell to Retailer',
    },
    notifications: {
      isRequired: 'is required',
      pleaseEnter: 'Please Enter',
      success: 'Success',
      succesfullyRemoved: 'Succesfully Removed',
      succesfullyAdded: 'Successfull Added',
      invalid: 'Invalid',
      fileType: 'File Type',
      fileTypeMessage: 'Only pdf or images are accepted',
      missingFileMessage: 'Please select a file type first',
      missingPhoneNumber: 'Please Enter Phone Number To Continue',
      maxQuantMess: 'Max Quantity Exceeded',
      alreadyRegisterdMsg: 'Number already registered as',
    },
    qtunits: {
      bag: 'Bags',
      metricTons: 'MT',
      kg: 'kg',
    },
    fmcg: {
      FMCG: 'FMCG',
    },
  };
};
